/**
 * 記号一式。
 *
 * 24 × 24 のグリッドに、 線幅 1.7、 端は角 (butt)、 角は面取りなし (miter)。
 * 内側 2px は余白として空ける。 直線・45°・円弧 R8.3 だけで描く。
 * 「線の太さと端の形が全部同じ」 であることがこの一式の唯一の約束。
 *
 * 文字グリフ (→ ▸ ✓ ✕ ●) の寄せ集めはここに置き換える。
 * CSS から出す記号 (疑似要素) は styles.css の `--ico-*` に同じ形が入っている。
 */

export type IconName =
  | 'next'
  | 'back'
  | 'close'
  | 'check'
  | 'open'
  | 'fold'
  | 'menu'
  | 'undo'
  | 'resign'
  | 'crown'
  | 'flag'
  | 'draw'
  | 'help';

const PATHS: Record<IconName, string> = {
  help: 'M20.3 12a8.3 8.3 0 1 1-16.6 0 8.3 8.3 0 0 1 16.6 0M9.6 9.2a2.5 2.5 0 0 1 4.8.8c0 1.7-2.4 2.1-2.4 3.6M12 16.2v1',
  next: 'M3.5 12h16M13.2 5.7 19.5 12l-6.3 6.3',
  back: 'M20.5 12h-16M10.8 5.7 4.5 12l6.3 6.3',
  close: 'M5.8 5.8 18.2 18.2M18.2 5.8 5.8 18.2',
  check: 'm4.5 12.6 5 5 10-11',
  open: 'm5 9.2 7 7 7-7',
  fold: 'm5 14.8 7-7 7 7',
  menu: 'M4 7h16M4 12h16M4 17h16',
  undo: 'M4.2 10.4h9.6a5.2 5.2 0 0 1 0 10.4H9M8.4 5.8l-4.2 4.6 4.2 4.6',
  resign: 'M6.3 3.5v17M6.3 5h12l-3 4 3 4h-12z',
  crown: 'M4 18.5V8l5 4.5L12 5.5l3 7 5-4.5v10.5z',
  /* 白旗 (負け): 竿 + 四角い旗。 投了 (resign) の燕尾旗とは別物。 */
  flag: 'M6 3.5v17M6 5h12v7.5H6',
  /* 引き分け: 天秤 (釣り合い)。 等号は小さいと意味が取れなかった。 */
  draw: 'M12 5v14M7 19h10M4 8h16M4 8l-3 6h6zM20 8l-3 6h6z',
};

export function Icon({
  name,
  size = 20,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="butt"
      strokeLinejoin="miter"
      aria-hidden
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
